const GuidelinesData = {
  fabrication: {
    detailsOfGuidelines: `• The MS Sections should be of prime quality free from rust , bends or dents
• Material should be ISI Mark and confirm to IS Standards.
• The frame must be cut to precise dimensions using mechanical or automated cutting equipments to maintain accuracy and prevent deformation.
• Welding should be carried out using MIG or ARC welding methods depending upon structural requirements.
• Joints must be full penetration weld , continuous and uniform in finish.
• All welds must be ground flushed and smooth to eliminate sharp edges and improve surface finish.
• For protective coating , apply one coat of red oxide / grey primer. All surfaces must be evenly coated with no sagging , drips or missed spots.
• Once Fabricated each unit must be inspected for squareness , surface finish , weld integrity and dimensional conformity before dispatch.`,
  },
  printing: {
    detailsOfGuidelines: `• The surface must be smooth and free from surface defects such as creases , wrinkles or pin holes.
• Printing must be carried out using solvent based inks compatible with the material ensuring strong adhesion , waterproofing , and resistance to fading under UV exposure.
• Color accuracy should be maintained as per the approved art work file and color branding , patching or grainy output will not be accepted.
• Before initiating mass production the vendor must share a printed sample or proof for client approval. Final printing shall not commence until the sample is being approved in writing.
• Print coverage must extend edge to edge considering safe margins for trimming and mounting. The printed area must be free from smudges , ink bleeding or scratches. All prints should be completely dry and free of odor before rolling or packing.
• Under no circumstances, the prints should not be folded or creased.`,
  },
  packaging: {
    detailsOfGuidelines: `• Every signage should carry a durable weather resistant label placed on the back side of the frame in a clearly visible position.
• The label must be printed , neatly and securely affixed using adhesive.
• Labels must remain intact during transportation , handling and installation.
• Smudged , torn or hand written labels will not be accepted unless pre approved for special circumstances.
• Labels shall be provided to Vendors by Pixell.
• Units without labels or incorrect details may be rejected at site or returned at the vendors expense.
• Due Diligence and care should be taken to ensure that the signage reaches the site safely and without any damages.`,
  },
  delivery: {
    detailsOfGuidelines: `
	• Delivery should be made with in a period of 7 days from the date of receipt of advance. 
• Failure to supply material in time would lead to lowering of star rating resulting in limited work opportunity.
• Payment Terms : 40% Advance , 40 % After successful PDI Inspection , Balance after 10 days of successful installation at site.`,
  },
  pdi: {
    detailsOfGuidelines: `• Signthought Solutions Private Limited i.e. Pixell , reserves the right to inspect any lot of printed or fabricated materials.
• Any signage not adhering to the above standards or found with defects ( Color Mismatch / Physical Damage ) will be rejected and must be replaced at vendor's cost.
• A test print / proof sample must be submitted for each campaign or new project before mass printing.
• Final prints should match the approved proof in color tone , quality , clarity and dpi.
• Once fabricated , each unit must be inspected for squareness , surface finish , weld integrity , and dimensional conformity before dispatch.`,
  },
  description: {
    detailsOfGuidelines: `• Standard size : 8'x4' ( Actual size may vary as per site recee report ) 
• Printing : Solvent Printing
• Substrate : 300 GSM , Black Back Nonlit Flex
• Brand : Pioneer / Star
• Transportation : Extra as Actual`,
  },
};

export default GuidelinesData;
